import { render } from "./delete-privacy.vue?vue&type=template&id=76d43e4d&scoped=true"
import script from "./delete-privacy.vue?vue&type=script&lang=js"
export * from "./delete-privacy.vue?vue&type=script&lang=js"

import "./delete-privacy.vue?vue&type=style&index=0&id=76d43e4d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d43e4d"]])

export default __exports__